import React from "react";
import {connect} from "react-redux";
import LayoutLoading from "../LayoutLoading";
import LayoutHeader from "../LayoutHeader";
import LayoutInformation from "../LayoutInformation";
import LayoutMembers from "../LayoutMembers";
import LayoutEpisodes from "../LayoutEpisodes";
import LayoutPartners from "../LayoutPartners";
import LayoutFooter from "../LayoutFooter";
import LayoutPlayer from "../LayoutPlayer";
import LayoutNominations from "../LayoutNomitations";
import LayoutExposition from "../LayoutExposition";
import LayoutExpositionLinks from "../LayoutExpositionLinks";
import LayoutTextBlock from "../LayoutTextBlock";
import LayoutCustomScheduleBlocks from "../LayoutCustomScheduleBlocks";
import LayoutPopup from "../LayoutPopup";
import {setWatchKey} from "../../actions/watchKey";
import {setEvent} from "../../actions/event";
import {exchangeKey, eventGet} from "../../api";
import "moment";
import locale from "../../locale";

const mainSettings = (window.eventSettings || []).find((settings) => settings.name === 'main');
if (mainSettings && mainSettings.locale) {
	locale.setLocale(mainSettings.locale);
}

switch (locale.currentLocaleName) {
	case 'ru':
		require(`moment/locale/ru`);
		break;
	case 'en':
		break;
}

class App extends React.Component
{
	constructor(props, context)
	{
		super(props, context);

		this.state = {
			watchKey: this.getWatchKey(),
			event: null,
			eventSettings: window.eventSettings || {},
		};
	}

	componentDidMount()
	{
		this.props.setWatchKey(this.getWatchKey());

	 	this.fetchEvent();
	}

	getWatchKey()
	{
		const match = location.pathname.match(/\/(watch|player)\/([a-z0-9]+)/);
		if (!match) {
			return null;
		}

		return match[2];
	}

	async fetchEvent()
	{
		const {watchKey} = this.state;

		const eventKey = await exchangeKey(watchKey)
			.then((response) => response.eventKey)
		;

		return await eventGet(eventKey)
			.then((event) => this.props.setEvent(event))
		;
	}

	render()
	{
		const {watchKey, event, registered} = this.props;
		const {eventSettings} = this.state;

		window.currentEvent = event;

		if (!event) {
			return (<LayoutLoading />);
		}

		const components = {
			information: LayoutInformation,
			nominations: LayoutNominations,
			members: LayoutMembers,
			episodes: LayoutEpisodes,
			partners: LayoutPartners,
			footer: LayoutFooter,
			exposition: LayoutExposition,
			"exposition-links": LayoutExpositionLinks,
			"text-block": LayoutTextBlock,
			"custom-schedule-blocks": LayoutCustomScheduleBlocks,
		};

		const playerSettings = eventSettings.find(s => s.name === 'player') || {};

		const bodySettings = eventSettings.find(s => s.name === 'main') || {};

		Object.keys(bodySettings.style || {}).forEach(key => {
			window.document.body.style[key] = bodySettings.style[key];
		});

		return (
			<div>
				<LayoutHeader eventSettings={eventSettings} />

				<LayoutPlayer settings={playerSettings} />

				{eventSettings
					.map((options, index) => {
						let Component = components[options.component || options.name];
						if (!Component) {
							return null;
						}
						if (options.showAfterRegistration && !registered) {
							return;
						}
						if (options.hasOwnProperty('enabled') && !options.enabled) {
							return;
						}

						return (
							<Component
								key={`component_${index}`}
								event={event}
								watchKey={watchKey}
								settings={options}
							/>
						);
					})
				}

				<LayoutPopup/>
			</div>
		);
	}
}

const mapStateToProps = (store) => ({
	watchKey: store.watchKey,
	event: store.event,
	registered: store.registered,
});

const mapDispatchToProps = (dispatch) => ({
	setWatchKey: watchKey => dispatch(setWatchKey(watchKey)),
	setEvent: event => dispatch(setEvent(event)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
